<template>
  <nav
    ref="sliderContainer"
    class="nav-faq-scroll slider"
    @mouseup="handleMouseUp"
    @mousedown="handleMouseDown"
    @mouseleave="handleMouseUp"
    @mousemove="handleMouseMove"
  >
    <div :style="{ transform: `translateX(${currentTranslateX}px)` }">
      <div class="items">
        <div
          v-for="(item, itemIndex) in items"
          :key="itemIndex"
          class="item"
          :class="{'is-active': route.path === localizePath(`/questions/${item.pageUrl}`) }"
          @click.prevent="select(`/questions/${item.pageUrl}`)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>

  </nav>
</template>

<script setup lang="ts">
  import type { IQuestionCategory } from '~/types';

  const props = defineProps<{
    currentLocaleData: IQuestionCategory[],
    defaultLocaleData: IQuestionCategory[],
  }>();
  const { localizePath } = useProjectMethods();
  const route = useRoute();
  const sliderContainer = ref(null);
  const router = useRouter();

  const { currentTranslateX, handleMouseDown, handleMouseMove, handleMouseUp, isMoved } = useSlider({
    sliderContainer,
  });

  const items = computed(() => props.currentLocaleData.length ? props.currentLocaleData : props.defaultLocaleData);

  watch(isMoved, (newValue) => {
    if (newValue) {
      setTimeout(() => {
        isMoved.value = false;
      }, 0);
    }
  });
  const select = (val:string) => {
    router.push(localizePath(val));
  };

</script>

<style src="~/assets/styles/components/nav/faq.scss" lang="scss" />
